import { RandomStringPipe } from '../../../../../../pipes/random-string.pipe';

export const ENVELOPE_LOOKUP_MODAL_ID = new RandomStringPipe().transform();
